import type { CSSProperties } from 'react';
const paths = {
  home: 'm3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z',
  activity: 'M8 5h13M8 12h13M8 19h13M3 5h.01M3 12h.01M3 19h.01',
  budget: 'M12 3a9 9 0 1 0 9 9h-9ZM15 3.5V9h5.5',
  insights: 'M4 20V11M10 20V4M16 20v-7M22 20H2',
  plus: 'M12 5v14M5 12h14',
  close: 'm6 6 12 12M18 6 6 18',
  receipt: 'M5 3v18l3-2 4 2 4-2 3 2V3l-3 2-4-2-4 2ZM8 9h8M8 13h6',
  scan: 'M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5M7 12h10',
  chevron: 'm9 5 7 7-7 7',
  check: 'm5 12 4 4L19 6',
  trash: 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7',
  undo: 'M9 5 3 11l6 6M3 11h11a6 6 0 0 1 6 6',
} as const;
export function Icon({ name, size = 22, style }: { name: keyof typeof paths; size?: number; style?: CSSProperties }) {
  return <svg className="app-icon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" style={style}><path d={paths[name]}/></svg>;
}
